import React from 'react'
//import PropTypes from 'prop-types'
import './style.css'

const AutoPlaySpinner = () => {
    return (
        <div className="lds-css ng-scope">
            <div style={{width:'100%',height:'100%'}}
                 className="lds-rolling">
                <div/>
            </div>
        </div>
    )
}

AutoPlaySpinner.propTypes = {}

AutoPlaySpinner.defaultProps = {}

export default AutoPlaySpinner



// WEBPACK FOOTER //
// ./src/components/_ead/AutoplaySpinner/index.js